import { Injectable } from '@angular/core';
import { NEVER } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { InfoCode } from 'src/app/models/domain';
import { InfoCodesDataService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';

@Injectable({ providedIn: 'root' })
export class InfoCodesService {
  private readonly state = new CollectionState<InfoCode>();

  public readonly infoCodes$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly infoCodesDataService: InfoCodesDataService) {}

  public add(infoCode: InfoCode) {
    this.state.add(infoCode);
  }

  public loadByDesignId(designId: string) {
    this.state.setLoading(true);

    return this.infoCodesDataService.getInfoCodesByDesignId(designId).pipe(
      tap((entities) => {
        this.state.set(entities);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }
}
